import { useCallback, useState } from 'react'
import {
  getAvailableDates,
  getAvailableTimeSlots,
  TimeSlotValue,
} from '../services/cinch-servicing'
import { AppointmentType } from '../types'

export const useFetchAppointmentAvailability = () => {
  const [loading, setLoading] = useState(false)
  const [timeSlotsLoading, setTimeSlotsLoading] = useState(false)
  const [appointmentDates, setAppointmentDates] = useState<string[]>()
  const [appointmentTypeId, setAppointmentTypeId] = useState<number>(5)
  const [timeSlots, setTimeSlots] = useState<TimeSlotValue[]>()
  const [error, setError] = useState<Error | null>(null)

  const fetchAppointmentDates = useCallback(
    async (
      dealerId: string | undefined,
      serviceOptionsSelectedNames: string | undefined,
      appointmentType: AppointmentType,
    ) => {
      if (!dealerId || !serviceOptionsSelectedNames || !appointmentType) {
        setLoading(false)
        setError(new Error('Missing value'))
        return
      }

      setLoading(true)
      setError(null)

      try {
        const dates = await getAvailableDates({
          dealerId,
          serviceOptions: serviceOptionsSelectedNames,
          appointmentType,
        })
        if (dates && dates.length > 0) {
          setAppointmentDates(dates[0].datesAvailable)
          setAppointmentTypeId(dates[0].id)
          setError(null)
        } else {
          setError(new Error('Failed to get appointment dates'))
        }
      } catch (error) {
        setError(error as Error)
      } finally {
        setLoading(false)
      }
    },
    [],
  )

  const fetchAppointmentTimes = useCallback(
    async (
      dealerId: string | undefined,
      appointmentTypeId: number,
      date: string,
    ) => {
      if (!dealerId || !appointmentTypeId || !date) {
        setTimeSlotsLoading(false)
        setError(new Error('Missing value'))
        return
      }

      setTimeSlotsLoading(true)
      setError(null)

      try {
        const avilableTimes = await getAvailableTimeSlots({
          dealerId,
          appointmentTypeId,
          date,
        })
        if (
          avilableTimes &&
          avilableTimes.timeSlots &&
          avilableTimes.timeSlots.length > 0
        ) {
          setTimeSlots(avilableTimes.timeSlots)
          setError(null)
        } else {
          setError(new Error('Failed to get time slots'))
        }
      } catch (error) {
        setError(error as Error)
      } finally {
        setTimeSlotsLoading(false)
      }
    },
    [],
  )

  return {
    fetchAppointmentDates,
    fetchAppointmentTimes,
    appointmentDates,
    appointmentTypeId,
    timeSlots,
    timeSlotsLoading,
    loading,
    error,
  }
}
